import React, { Component } from "react";
import FormView from "../components/FormView";
import Title from "../components/SidePanel/Title";
import { Switch, Route } from 'react-router' // react-router v4
import VerificationContainer from "../containers/VerificationContainer";

export default class VerificationRoute extends Component {

    render() {
        
        return (
            <Switch>
                <Route exact path="/verification/:uid/:code" render={props => {
                    return (
                    <FormView
                        content={ <VerificationContainer {...props}/> }
                        sideContent={ <Title/> }
                    />
                );}}
                />
            </Switch>
        );
    }

}